// SP判定関数
window.Common = {
  isMobile: function() {
    return window.innerWidth <= 768;
  }
};

window.addEventListener('load', () => {
  document.body.classList.add('is-visible');
});

document.addEventListener('DOMContentLoaded', function () {
  //マウスポインタ
  function mousePointer(){
    const pointer = document.getElementById('mouse-pointer');
    const pointerText = document.querySelector('.mouse-pointer-text');
    const pointerDefroute = document.querySelector('.mouse-pointer-defroute');
    const pointerNext = document.querySelector('.mouse-pointer-next');
    const pointerPrev = document.querySelector('.mouse-pointer-prev');
    
    let mouseMoveHandler = null;
    let mouseLeaveHandler = null;
    let mouseEnterHandler = null;
  
    // ポインタ初期化関数
    function initCustomPointer() {
      // イベントを初期化
      removePointerEvents();
      
      if (!window.Common.isMobile()) { // モバイルでない場合にのみ実行
        handleMouseMove();
        handleMouseLeaveEnter();
        setupHoverEffects();
        setupNextEffects();
        setupPrevEffects();
        pointer.style.display = 'block';
      } else {
        // モバイルではポインタを非表示にしておく
        pointer.style.display = 'none';
      }
    }
  
    // イベントリスナーを解除する関数
    function removePointerEvents() {
      if (mouseMoveHandler) {
        document.removeEventListener('mousemove', mouseMoveHandler);
      }
      if (mouseLeaveHandler) {
        document.removeEventListener('mouseleave', mouseLeaveHandler);
      }
      if (mouseEnterHandler) {
        document.removeEventListener('mouseenter', mouseEnterHandler);
      }
    }
  
    // マウスの動きを追従させる
    function handleMouseMove() {
      mouseMoveHandler = function (e) {
        pointer.style.transform = `translate(${e.clientX}px, ${e.clientY}px)`;
        pointer.style.display = 'block'; // ポインタ表示
      };
      document.addEventListener('mousemove', mouseMoveHandler);
    }
  
    // マウスがウィンドウに出入りする際の処理
    function handleMouseLeaveEnter() {
      mouseLeaveHandler = function () {
        pointer.style.display = 'none'; // ポインタ非表示
      };
      document.addEventListener('mouseleave', mouseLeaveHandler);
  
      mouseEnterHandler = function () {
        pointer.style.display = 'block'; // ポインタ再表示
      };
      document.addEventListener('mouseenter', mouseEnterHandler);
    }
  
    // hover-text-containerのホバー効果を設定
    function setupHoverEffects() {
      document.querySelectorAll('.hover-text-container').forEach(container => {
        container.addEventListener('mouseenter', function () {
          const hoverText = this.dataset.hoverText; // data-hover-textからテキストを取得
          pointerText.textContent = hoverText; // テキスト表示
          pointerText.style.display = 'block';
          pointerDefroute.style.display = 'none'; // 円形ポインタ非表示
          pointerNext.style.display = 'none';
          pointerPrev.style.display = 'none'
        });
  
        container.addEventListener('mouseleave', function () {
          pointerText.style.display = 'none'; // テキスト非表示
          pointerDefroute.style.display = 'block'; // 円形ポインタ再表示
          pointerNext.style.display = 'none';
          pointerPrev.style.display = 'none'
        });
      });
    }

    function setupNextEffects(){
      document.querySelectorAll('.hover-next-container').forEach(container => {
        container.addEventListener('mouseenter', function () {
          pointerText.style.display = 'none';
          pointerDefroute.style.display = 'none'; // 円形ポインタ非表示
          pointerNext.style.display = 'block';
          pointerPrev.style.display = 'none'
          pointerPrev.style.display = 'none'
        });
  
        container.addEventListener('mouseleave', function () {
          pointerText.style.display = 'none';
          pointerDefroute.style.display = 'block';
          pointerNext.style.display = 'none';
        });
      });
    }

    function setupPrevEffects(){
      document.querySelectorAll('.hover-prev-container').forEach(container => {
        container.addEventListener('mouseenter', function () {
          pointerText.style.display = 'none';
          pointerDefroute.style.display = 'none'; // 円形ポインタ非表示
          pointerNext.style.display = 'none';
          pointerPrev.style.display = 'block'
        });
  
        container.addEventListener('mouseleave', function () {
          pointerText.style.display = 'none';
          pointerDefroute.style.display = 'block';
          pointerNext.style.display = 'none';
          pointerPrev.style.display = 'none'
        });
      });
    }
  
    // ポインタ初期化
    initCustomPointer();
  
    // リサイズ時に再度チェックしてポインタの動作を更新
    window.addEventListener('resize', initCustomPointer);
  }
  mousePointer();
});


//商品一覧スライダ
function productSlider(){
  function productSplide(){
    document.querySelectorAll('.product-item').forEach(function(productItem, index) {
      // 各product-item内のスライダーを取得
      
      var itemSlider = new Splide(productItem.querySelector('.splide.item-slider'), {
        perPage: 1,
        pagination: false,
        lazyLoad: 'nearby',
        arrows: true,
        type: 'loop',
      });
    
      // 各product-item内のプログレスバーを取得
      var bar = productItem.querySelector('.my-carousel-progress__bar');
      
      // 各product-item内の.item-data__colorボタンを取得
      var buttons = productItem.querySelectorAll('.item-data__color button');
    
      // スライドの移動時にプログレスバーとis-activeクラスを更新
      itemSlider.on('mounted move', function () {
        var end = itemSlider.Components.Controller.getEnd() + 1;
        var rate = Math.min((itemSlider.index + 1) / end, 1);
        bar.style.width = String(100 * rate) + '%';
    
        // is-activeクラスの付け替え
        buttons.forEach(function(button, buttonIndex) {
          if (buttonIndex === itemSlider.index) {
            button.classList.add('is-active');
          } else {
            button.classList.remove('is-active');
          }
        });
      });

      // 動き出したタイミングで処理を実行
      itemSlider.on('move', function () {
        productItem.classList.add('slider-move');
      });
      itemSlider.on('drag', function () {
        productItem.classList.add('slider-move');
      });
      // 動き出したタイミングで処理を実行
      itemSlider.on('moved', function () {
        productItem.classList.remove('slider-move');
      });
      itemSlider.on('dragged', function () {
        productItem.classList.remove('slider-move');
      });
    
      // 各ボタンにクリックイベントを追加
      buttons.forEach(function(button, buttonIndex) {
        button.addEventListener('click', function() {
          itemSlider.go(buttonIndex); // 該当スライドに移動
        });
      });
    
      // スライダーの初期化
      itemSlider.mount();
    });
  }
  productSplide();

  //フィルタかかったときに商品スライダを最初期化する
  //初期化ターゲット
  const productGrid = document.querySelector('.filters-adjacent');
  if (productGrid) {
    // 変更があった際に実行するコールバック関数
    const callback = function(mutationsList, observer) {
        for (let mutation of mutationsList) {
            if (mutation.type === 'childList') {
              productSplide();
            }
        }
    };
    // 監視するオプション
    const config = {
        childList: true,  // 子要素の追加や削除を監視
        subtree: false    // 子孫ノードは監視しない
    };
    // MutationObserverを作成して監視を開始
    const observer = new MutationObserver(callback);
    observer.observe(productGrid, config);
  }

  // .filter-containerのクラス変更を監視
  const filterContainer = document.querySelector('.filter-container');
  if (filterContainer) {
    // 変更があった際に実行するコールバック関数
    const filterCallback = function(mutationsList, observer) {
      for (let mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          productSplide();
        }
      }
    };
    // 監視するオプション
    const filterConfig = {
      attributes: true,  // 属性の変更を監視
      attributeFilter: ['class']  // クラス属性のみ監視
    };
    // MutationObserverを作成して監視を開始
    const filterObserver = new MutationObserver(filterCallback);
    filterObserver.observe(filterContainer, filterConfig);
  }
}
document.addEventListener('DOMContentLoaded', function () {
  productSlider();
});
document.addEventListener("shopify:section:load", () => {
  productSlider();
});

let matchPoint = gsap.matchMedia(),breakPoint = 800;
gsap.registerPlugin(ScrollTrigger);
document.addEventListener('DOMContentLoaded', function () {
  matchPoint.add(`(min-width: ${breakPoint}px)`, () => {
    topConceptAnimation();
  });
  matchPoint.add(`(max-width: ${breakPoint - 1}px)`, () => {
    topConceptAnimationSp();
  });
});


/*TOPコンセプトアニメーション*/
function topConceptAnimation() {
  // 複数のターゲット要素を取得
  const leftToRightElements = document.querySelectorAll(".top-concept__item.left-to-right");
  const rightToLeftElements = document.querySelectorAll(".top-concept__item.right-to-left");
  const bottomToTopElements = document.querySelectorAll(".top-concept__item.bottom-to-top");

  // left-to-right アニメーション
  leftToRightElements.forEach((element) => {
    gsap.from(element, {
      x: "-100vw",
      scrollTrigger: {
        trigger: element,
        start: "top 80%",
        end: "top 30%",
        scrub: 0.8,
      }
    });
  });

  // right-to-left アニメーション
  rightToLeftElements.forEach((element) => {
    gsap.from(element, {
      x: "100vw",
      scrollTrigger: {
        trigger: element,
        start: "top 80%",
        end: "top 30%",
        scrub: 0.8,
      }
    });
  });

  // bottom-to-top アニメーション
  bottomToTopElements.forEach((element) => {
    gsap.from(element, {
      y: "150px",
      scrollTrigger: {
        trigger: element,
        start: "top 98%",
        end: "top 95%",
        scrub: 0.8,
        markers: false
      }
    });
  });
}

function topConceptAnimationSp() {
  // 複数のターゲット要素を取得
  const leftToRightElements = document.querySelectorAll(".top-concept__item.left-to-right");
  const rightToLeftElements = document.querySelectorAll(".top-concept__item.right-to-left");
  const bottomToTopElements = document.querySelectorAll(".top-concept__item.bottom-to-top");

  // left-to-right アニメーション
  leftToRightElements.forEach((element) => {
    gsap.from(element, {
      x: "-100vw",
      scrollTrigger: {
        trigger: element,
        start: "top 80%",
        end: "top 30%",
        scrub: 0.8,
      }
    });
  });

  // right-to-left アニメーション
  rightToLeftElements.forEach((element) => {
    gsap.from(element, {
      x: "100vw",
      scrollTrigger: {
        trigger: element,
        start: "top 80%",
        end: "top 30%",
        scrub: 0.8,
      }
    });
  });

  // bottom-to-top アニメーション
  bottomToTopElements.forEach((element) => {
    gsap.from(element, {
      y: "150px",
      scrollTrigger: {
        trigger: element,
        start: "top 98%",
        end: "top 95%",
        scrub: 0.8,
        markers: false
      }
    });
  });
}

//ここから/sections/collection-list.liquid
/*
function collectionListSplide() {
  document.querySelectorAll('.collection-list').forEach(function(collectionItem) {
    // 既存のSplideインスタンスがある場合は破棄
    const splideElement = collectionItem.querySelector('.splide.collection-slider');
    if (splideElement.splide) {
      splideElement.splide.destroy();
    }

    // 新しいSplideインスタンスを作成
    var itemSlider = new Splide(splideElement, {
      type:'free',
      drag: true,
      perPage      : 1,
      pagination: false,
      lazyLoad: 'nearby',
      arrows: false,
      height: '134px',
      autoWidth: true,
      rewind       : false,     // スライドの巻き戻し無効化
      waitForTransition: false, // スライド中の操作制限を無効化
      snap         : false,     // スナップ動作無効化
      breakpoints: {
        767: {
          height: '190px',
        },
      },
    });
    itemSlider.mount();
  });
};
*/
function collectionListHover() {
  if (window.innerWidth > 768) {
    document.querySelectorAll('.collection-wrap .collection-list').forEach(function(item) {
      // 各要素にタイマーIDを保存するプロパティを初期化
      item.hoverTimeout = null;

      // イベントリスナーを追加する前に古いリスナーを削除
      item.removeEventListener('mouseenter', handleMouseEnter);
      item.removeEventListener('mouseleave', handleMouseLeave);

      // 新しいイベントリスナーを追加
      item.addEventListener('mouseenter', handleMouseEnter);
      item.addEventListener('mouseleave', handleMouseLeave);
    });
  }

  function handleMouseEnter() {
    // クラスを即座に追加
    this.classList.add('is-visible');

    // 古いタイマーが存在すればクリアする
    if (this.hoverTimeout) {
      clearTimeout(this.hoverTimeout);
      this.hoverTimeout = null;
    }
  }

  function handleMouseLeave() {
    // 既存のタイマーがない場合のみ新しいタイマーを設定
    this.hoverTimeout = setTimeout(() => {
      this.classList.remove('is-visible');
      this.hoverTimeout = null; // タイマーIDをリセット
    }, 3000); // 3秒後にクラスを外す
  }
};

document.addEventListener('DOMContentLoaded', function() {
  /*collectionListSplide();*/
  collectionListHover();
});

document.addEventListener("shopify:section:load", () => {
  /*collectionListSplide();*/
  collectionListHover();
});
//ここまで /sections/collection-list.liquid

/*headerPCのときの黒色判定 */
function headerMenuMainBlack(){
  document.querySelectorAll('.header__menu__main.pc-only .hover-black').forEach(function(hoverElement) {
    hoverElement.addEventListener('mouseenter', function() {
      const menu = hoverElement.closest('.menu');
      if (menu) {
        menu.classList.add('is-black');
      }
    });
  
    hoverElement.addEventListener('mouseleave', function() {
      const menu = hoverElement.closest('.menu');
      if (menu) {
        menu.classList.remove('is-black');
      }
    });
  });
}
document.addEventListener('DOMContentLoaded', function() {
  headerMenuMainBlack();
});

document.addEventListener("shopify:section:load", () => {
  headerMenuMainBlack();
});